// libs
import { Action, StateFromReducersMapObject, combineSlices } from '@reduxjs/toolkit'
import { LOGOUT_ACTION } from 'store/types'
// reducers
import { reducer as formReducer } from 'redux-form'
import { modalsSlice } from 'store/reducers/modals'
import { offlineRiskSlice } from 'store/reducers/offlineRisk'
import { riskViewsSlice } from 'store/reducers/riskViews'
import { publicFormSlice } from 'store/reducers/publicRisk'
import { dashboardsSlice } from 'store/reducers/dashboards'
import { currentUserSlice } from 'store/reducers/currentUser'
import { relatedFormsSlice } from 'store/reducers/relatedForms'
import { riskTemplatesSlice } from 'store/reducers/riskTemplates'
import { objectEntitiesSlice } from 'store/reducers/objectEntities'
import { accumulatedFormSlice } from 'store/reducers/accumulatedForms'
import { objectSecuritiesSlice } from 'store/reducers/objectSecurities'
import { securityProfilesSlice } from 'store/reducers/securityProfiles'
import { twoFactorAuthSlice } from 'store/reducers/twoFactorAuth'

const combinedReducer = combineSlices(
  { form: formReducer },
  modalsSlice,
  offlineRiskSlice,
  riskViewsSlice,
  dashboardsSlice,
  publicFormSlice,
  currentUserSlice,
  relatedFormsSlice,
  riskTemplatesSlice,
  objectEntitiesSlice,
  accumulatedFormSlice,
  objectSecuritiesSlice,
  securityProfilesSlice,
  twoFactorAuthSlice
)

const rootReducer = (state: StateFromReducersMapObject<any>, action: Action) => {
  if (action.type === LOGOUT_ACTION) {
    state = {}
  }

  return combinedReducer(state, action)
}

export default rootReducer
